<template>
  <div class="">
    <h3 class="pt-0 mt-0 pb-0" v-if="exportName==='avito'">{{ $t("viewSettings.goods_export.parameters_for_avito") }}</h3>
    <h3 class="pt-0 mt-0 pb-0" v-if="exportName==='zzap'">{{ $t("viewSettings.goods_export.parameters_for_zzap") }}</h3>
    <v-card class="mt-2" elevation="0">
      <v-flex xs12 md6>
        <h4>{{ this.$t('common.storage') }}: {{currentParams && currentParams.storage && currentParams.storage.name}}</h4>
        <v-form ref="goodsExportForm">
          <template v-if="exportName==='ozon' && paramsValues && currentParams && tempParams.storage_id">
            <goods-export-form-ozon :params-values="paramsValues" :params.sync="tempParams" :storage="currentParams.storage"/>
          </template>
          <template v-if="exportName==='zzap' && paramsValues">
            <v-text-field v-model="tempParams.delivery_time" :label="$t('viewSettings.goods_export.delivery_time')" :disabled="!!nowUpdatingExportForStorageWithId" outlined/>
            <v-text-field v-model="tempParams.multiplicity_packing" :label="$t('viewSettings.goods_export.multiplicity_packing')" :disabled="!!nowUpdatingExportForStorageWithId" outlined/>
            <v-select
                :label="$t('viewSettings.goods_export.not_original')"
                :items="paramsValues.filter((item)=>item.type==='not_original')"
                item-text="name"
                item-value="id"
                v-model="tempParams.not_original_id"
                class="pointer"
                clearable
                outlined
                :disabled="!!nowUpdatingExportForStorageWithId"
            ></v-select>
            <v-select
                :label="$t('viewSettings.goods_export.used_and_markdown')"
                :items="paramsValues.filter((item)=>item.type==='used_and_markdown')"
                item-text="name"
                item-value="id"
                v-model="tempParams.used_and_markdown_id"
                class="pointer"
                clearable
                outlined
                :disabled="!!nowUpdatingExportForStorageWithId"
            ></v-select>
            <v-select
                :label="$t('viewSettings.goods_export.safe_deal')"
                :items="paramsValues.filter((item)=>item.type==='safe_deal')"
                item-text="name"
                item-value="id"
                v-model="tempParams.safe_deal_id"
                class="pointer"
                clearable
                outlined
                :disabled="!!nowUpdatingExportForStorageWithId"
            ></v-select>
          </template>
          <template v-if="exportName==='avito' && paramsValues">
            <v-checkbox v-model="tempParams.is_enabled" :label="$t('common.enabled')" :disabled="!!nowUpdatingExportForStorageWithId" />
            <v-text-field v-model="tempParams.Address" :label="$t('common.address')" :disabled="!!nowUpdatingExportForStorageWithId" outlined/>
            <v-text-field v-model="tempParams.ContactPhone" :label="$t('common.phone')"  :disabled="!!nowUpdatingExportForStorageWithId" outlined/>
            <v-text-field v-model="tempParams.ManagerName" :label="$t('viewSettings.goods_export.manager_name')" :disabled="!!nowUpdatingExportForStorageWithId" outlined/>
              <v-autocomplete
                  :items="paramsValues.filter((item)=>item.type==='DisplayArea')"
                  :label="$t('viewSettings.goods_export.display_areas')"
                  chips
                  outlined
                  deletable-chips
                  item-text="name"
                  item-value="value"
                  multiple
                  v-model="tmpDisplayAreas"
                  :disabled="!!nowUpdatingExportForStorageWithId"
              ></v-autocomplete>
            <v-select
                :label="$t('viewSettings.goods_export.ad_status')"
                :items="paramsValues.filter((item)=>item.type==='AdStatus')"
                item-text="name"
                item-value="id"
                v-model="tempParams.AdStatus_id"
                class="pointer"
                clearable
                outlined
                :disabled="!!nowUpdatingExportForStorageWithId"
            ></v-select>
            <v-select
                :label="$t('viewSettings.goods_export.goods_type')"
                :items="paramsValues.filter((item)=>item.type==='GoodsType')"
                item-text="name"
                item-value="id"
                v-model="tempParams.GoodsType_id"
                class="pointer"
                clearable
                outlined
                :disabled="!!nowUpdatingExportForStorageWithId"
            ></v-select>
            <v-select
                :label="$t('viewSettings.goods_export.product_type')"
                :items="paramsValues.filter((item)=>item.type==='ProductType')"
                item-text="name"
                item-value="id"
                v-model="tempParams.ProductType_id"
                class="pointer"
                clearable
                outlined
                :disabled="!!nowUpdatingExportForStorageWithId"
            ></v-select>
            <v-select
                :label="$t('viewSettings.goods_export.spare_part_type')"
                :items="paramsValues.filter((item)=>item.type==='SparePartType')"
                item-text="name"
                item-value="id"
                v-model="tempParams.SparePartType_id"
                class="pointer"
                clearable
                outlined
                :disabled="!!nowUpdatingExportForStorageWithId"
            ></v-select>
            <v-select
                :label="$t('viewSettings.goods_export.contact_method')"
                :items="paramsValues.filter((item)=>item.type==='ContactMethod')"
                item-text="name"
                item-value="id"
                v-model="tempParams.ContactMethod_id"
                class="pointer"
                clearable
                outlined
                :disabled="!!nowUpdatingExportForStorageWithId"
            ></v-select>
            <v-select
                :label="$t('viewSettings.goods_export.category')"
                :items="paramsValues.filter((item)=>item.type==='Category')"
                item-text="name"
                item-value="id"
                v-model="tempParams.Category_id"
                class="pointer"
                clearable
                outlined
                :disabled="!!nowUpdatingExportForStorageWithId"
            ></v-select>
            <v-select
                :label="$t('viewSettings.goods_export.ad_type')"
                :items="paramsValues.filter((item)=>item.type==='AdType')"
                item-text="name"
                item-value="id"
                v-model="tempParams.AdType_id"
                class="pointer"
                clearable
                outlined
                :disabled="!!nowUpdatingExportForStorageWithId"
            ></v-select>
            <v-select
                :label="$t('viewSettings.goods_export.condition')"
                :items="paramsValues.filter((item)=>item.type==='Condition')"
                item-text="name"
                item-value="id"
                v-model="tempParams.Condition_id"
                class="pointer"
                clearable
                outlined
                :disabled="!!nowUpdatingExportForStorageWithId"
            ></v-select>
          </template>
          <v-divider></v-divider>
          <v-spacer></v-spacer>
          <v-btn
              :disabled="!!nowUpdatingExportForStorageWithId"
              :loading="!!nowUpdatingExportForStorageWithId"
              class="mt-5 white--text mr-4"
              elevation="0"
              color="red"
              :to="{ name: 'settings-goods-export'}"
          >
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
              :disabled="!!nowUpdatingExportForStorageWithId"
              :loading="!!nowUpdatingExportForStorageWithId"
              class="mt-5"
              elevation="0"
              color="primary"
              @click="submit"
              @keyup.enter="submit"
          >
            {{ $t('common.save') }}
          </v-btn>
        </v-form>
      </v-flex>
    </v-card>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import GoodsExportFormOzon from "@/views/Settings/GoodsExportFormOzon";

export default {
  name: "GoodsExportForm",
  components: {GoodsExportFormOzon},
  data: () => ({
    tempParams:{},
    tmpDisplayAreas: [],
    activeCategory: []
  }),
  created() {
    this.onLoad();
  },

  watch: {
    '$route'(to, from) {
      this.onLoad();
    },
    tmpDisplayAreas(to){
      if(to.length){
        this.tempParams.DisplayAreas = to.join('|')
      } else {
        this.tempParams.DisplayAreas = ''
      }
    }
  },
  computed: {
    ...mapFields("storages", ["storageExportParams", "nowUpdatingExportForStorageWithId", "storageExportParamsValues", "isFetchedGoodsExportParameterValues"]),
    exportName(){
      return this.$route.params.type;
    },
    currentParams(){
      return this.storageExportParams[this.exportName];
    },
    paramsValues(){
      return this.storageExportParamsValues[this.exportName];
    }
  },
  methods: {
    onLoad() {
      this.$store.dispatch('storages/getGoodsExportParameterValues', {'export_name':this.exportName}).then(()=>{
        let parameters = {
          storage_id: this.$route.params.id,
          export_name: this.exportName,
        };
        this.$store.dispatch("storages/getGoodsExportParameters", parameters).then(()=>{
          this.tempParams = this.currentParams
          if(this.currentParams && this.currentParams.DisplayAreas) {
            this.tmpDisplayAreas = this.currentParams.DisplayAreas.split('|');
          }
        })
      })
    },
    submit() {
      if (this.$refs['goodsExportForm'].validate()) {
        let parameters = {
          export_name: this.exportName,
          ...this.tempParams
        };
        this.$store.dispatch("storages/setGoodsExportParameters", parameters);
      }
    }
  }
}
</script>

<style scoped>

</style>